import React from 'react';
import { Box, Typography } from '@mui/material';

import { FormInput } from '@src/components/form-input';

import { useRedeemTransactionsContext } from '../provider';

const boxStyle = {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 1,
    marginTop: 2,
};

const PaypalDetails = ({ control }: any) => {
    const { state } = useRedeemTransactionsContext();
    const { selected } = state || {};

    if (selected?.redeemTypeID !== 2) return null;

    return (
        <>
            <Typography sx={{ m: 0, p: 2, fontSize: 14, fontWeight: "600" }}>
                Paypal Details
            </Typography>
            <Box sx={boxStyle}>
                <FormInput
                    name="paypal_FirstName"
                    control={control}
                    label="First Name"
                    disabled
                />
                <FormInput
                    name="paypal_LastName"
                    control={control}
                    label="Last Name"
                    disabled
                />
            </Box>
            <Box sx={boxStyle}>
                <FormInput
                    name="bank_Name"
                    control={control}
                    label="Paypal Username"
                    disabled
                />
                <FormInput
                    name="paypal_Email"
                    control={control}
                    label="Paypal Email"
                    disabled
                />
            </Box>
        </>
    );
}

export default PaypalDetails;